import { gql, useMutation } from '@apollo/client'
import { OktaUserInput, OktaUser } from 'shared/__gql-types'


export const CREATE_OKTA_USER = gql`
  mutation ($input: OktaUserInput!) {
    createOktaUser(input: $input) {
      id
      profile {
        email
        firstName
        homeOrg
        lastName
        managementCompany
        mobilePhone
        role
      }
      activation
    }
  }
`

export const useCreateOktaUser = () => {
  const [mutate, { data, loading, error }] = useMutation<
  { createOktaUser: OktaUser },
  { input: OktaUserInput }
>(CREATE_OKTA_USER, {
  update(cache) {
    cache.modify({
      fields: {
        listUsers() {}
      }
    })
  }
})

  return { mutate, data, loading, error }
}
